// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"aec72b50","276":"46ba42d8","400":"b04e58c6","511":"35a19897","562":"879189f5","817":"6033e84a","905":"afe285cc"}[chunkId] + ".chunk.js";
};